module.exports = __webpack_public_path__ + "img/robert-piosek-old.49b95f87.jpg";